import { render, staticRenderFns } from "./mobileSelect.vue?vue&type=template&id=0c990246&"
import script from "./mobileSelect.vue?vue&type=script&lang=ts&"
export * from "./mobileSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports